import { DepositIcon } from "@xola/icons";
import React from "react";
import { Audit, LineItemType, PaymentLineItem, PaymentMethod, Purchase, PurchaseItem } from "types";
import { TimelineItem } from "../TimelineItem";
import PaymentTimelineItemContent from "./PaymentTimelineItemContent";

interface GratuityTransferTimelineItemProps {
    showDate?: boolean;
    purchase: Purchase;
}

export const GratuityTransferTimelineItem = ({ showDate = false, purchase }: GratuityTransferTimelineItemProps) => {
    const gratuityLineItem = purchase.lineItems.find((lineItem) => lineItem.type === LineItemType.GRATUITY_TRANSFER);
    if (!gratuityLineItem) {
        return null;
    }
    return (
        <TimelineItem
            title="Gratuity Received"
            audit={gratuityLineItem}
            icon={<DepositIcon />}
            color="success"
            showDate={showDate}
        >
            <PaymentTimelineItemContent
                amount={-1 * gratuityLineItem.amount}
                method={PaymentMethod.INTERNAL}
                comment="Gratuity Transferred"
            />
        </TimelineItem>
    );
};

GratuityTransferTimelineItem.supportsAudit = (
    _purchase: Purchase,
    _item: PurchaseItem,
    _audit: Audit,
    _lineItem?: PaymentLineItem,
    _timezone?: string,
    change?: any,
) => {
    if (!change || change.type !== LineItemType.GRATUITY_TRANSFER) {
        return false;
    }

    const gratuityLineItems = _purchase.lineItems.filter((l) => l.type === LineItemType.GRATUITY_TRANSFER);

    const uniquePurchaseItemsWithGratuity = new Map();
    for (const lineItem of gratuityLineItems) {
        if (lineItem.purchaseItem?.id && !uniquePurchaseItemsWithGratuity.has(lineItem.purchaseItem.id)) {
            uniquePurchaseItemsWithGratuity.set(lineItem.purchaseItem.id, lineItem.id);
        }
    }

    return (
        uniquePurchaseItemsWithGratuity.has(change.purchaseItem?.id) &&
        uniquePurchaseItemsWithGratuity.get(change.purchaseItem?.id) === change.id
    );
};
